import { Colors, Icon, MediumIcon, SmallIcon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TooltipWrapper from '../TooltipWrapper'

export type Props = {
  children: React.ReactNode
  label: string | React.ReactNode
}

const TooltipIcon = ({ children, label }: Props) => {
  return <TooltipWrapper.Alt label={label}>{children}</TooltipWrapper.Alt>
}

type SmallProps = {
  icon: SmallIcon
  label: string | React.ReactNode
  color?: Colors
}

const Small = observer(({ icon, label, color = 'grey1000' }: SmallProps) => {
  return (
    <TooltipIcon label={label}>
      <Icon.Small icon={icon} color={color} />
    </TooltipIcon>
  )
})

type MediumProps = {
  icon: MediumIcon
  label: string | React.ReactNode
  color?: Colors
}

const Medium = observer(({ icon, label, color = 'grey1000' }: MediumProps) => {
  return (
    <TooltipIcon label={label}>
      <Icon.Medium icon={icon} color={color} />
    </TooltipIcon>
  )
})

TooltipIcon.Small = Small
TooltipIcon.Medium = Medium

export default TooltipIcon
